<template>
  <div class="tab-container">
    <h4>Supprimer votre compte</h4>
    <!-- <InputWrapper
      label="Pour quelle raison souhaitez-vous supprimer votre compte?"
      placeholder="Indiquez-nous ce qui n'a pas fonctionné"
      input="textarea"
      name="delete-account-explaination"
      v-model="state.explaination"
      rows="7"
    />
    <InputWrapper
      label="Entrez votre mot de passe"
      type="password"
      placeholder="••••••••••••"
      name="delete-account-password"
      v-model="state.password"
      :required="true"
    />
    <Button class="red" label="Supprimer mon compte" :disabled="canDelete" /> -->
    <p>
      Afin de supprimer votre compte veuillez contacter le
      <span class="virtual-link" @click="crisp.chat.open()">service client</span
      >.
    </p>
    <p class="small">
      La suppression de votre compte est définitive. Votre profil et l’ensemble
      des vos informations personnelles seront définitivement supprimés.
    </p>
    <p>
      <a href="https://yuzu.hr/legal/cgu.pdf" target="_blank"
        >Conditions de service</a
      >
      |
      <a href="https://yuzu.hr/legal/privacy.pdf" target="_blank"
        >Politique de confidentialité</a
      >
    </p>
  </div>
</template>

<script setup>
import { reactive, computed, inject } from "vue";

const crisp = inject("crisp");

const state = reactive({
  explaination: "",
  password: "",
});

const canDelete = computed(() => {
  return state.explaination && state.password.length > 7;
});
</script>
